import { Component, OnInit, Input } from '@angular/core';
import { Payee } from '../../models/payee';

@Component({
  standalone: false,
  selector: 'app-edit-payee',
  templateUrl: './edit-payee.component.html',
styleUrls:  ['./edit-payee.component.css']
})
export class EditPayeeComponent implements OnInit {

 @Input() payee: Payee;
 @Input() has_usef_contact_override: boolean;
  useGoogleAddress: boolean = true;

  constructor() { }

  ngOnInit() {
  }

  handleSelectState(state: string){
    this.payee.state = state;
  }

  updateAddressFromAutocomplete(addr: any) {

    console.log(addr);

    this.payee.address_1 = `${addr.street_number || ''} ${addr.route || ''}`.trim();
    this.payee.city = addr.city || '';
    this.payee.state = addr.state || '';
    this.payee.zip = `${addr.zip || ''} ${addr.zipPlus4 || ''}`.trim();
    this.payee.country = addr.country || 'United States';
  }

  ssnInvalid = false;
  einInvalid = false;
  foreignTinInvalid = false;

  // The API never returns a full SSN, ITIN or foreign TIN - it sends ***-**-1234, and keeps the stored number when that comes back unchanged
  static readonly MASKED_SSN = /^\*{3}-\*{2}-.{4}$/;

  get ssnIsMasked(): boolean {
    return EditPayeeComponent.MASKED_SSN.test(this.payee?.ssn ?? '');
  }

  get foreignTinIsMasked(): boolean {
    return EditPayeeComponent.MASKED_SSN.test(this.payee?.foreign_tin ?? '');
  }

  validateForeignTin(value: string) {
    // Untouched mask is fine; a partly edited one is neither the stored number nor a new one
    this.foreignTinInvalid = (value ?? '').includes('*') && !EditPayeeComponent.MASKED_SSN.test(value);
  }

  validateSSN(value: string) {
    if ((value ?? '').includes('*')) {
      // Untouched mask is fine; a partly edited one is neither the stored number nor a new one
      this.ssnInvalid = !EditPayeeComponent.MASKED_SSN.test(value);
      return;
    }

    const d = (value ?? '').replace(/[^0-9]/g, '');
    if (!d) { this.ssnInvalid = false; return; }

    const area   = d.slice(0, 3);
    const group  = d.slice(3, 5);
    const serial = d.slice(5);

    this.ssnInvalid =
      d.length !== 9            ||
      /^(000|666|9)/.test(area) ||  // IRS: these area codes are never assigned
      group === '00'            ||  // IRS: middle group can never be 00
      serial === '0000'         ||  // IRS: serial group can never be 0000
      /^(.)\1{8}$/.test(d)      ||  // all-same digit (e.g. 111-11-1111)
      d === '078051120'         ||  // Woolworth wallet SSN — widely used fraudulently
      d === '219099999';            // IRS-published never-assigned number
  }

  validateEIN(value: string) {
    const d = (value ?? '').replace(/[^0-9]/g, '');
    if (!d) { this.einInvalid = false; return; }

    const prefix = parseInt(d.slice(0, 2), 10);
    const INVALID_PREFIXES = new Set([0, 7, 8, 9, 17, 18, 19, 28, 29, 49, 69, 78, 79, 89, 96, 97]);

    this.einInvalid =
      d.length !== 9               ||
      INVALID_PREFIXES.has(prefix) ||  // unassigned IRS campus codes
      /^(.)\1{8}$/.test(d)         ||  // all-same digit (e.g. 11-1111111)
      d.slice(2) === '0000000';        // all-zero body
  }

}
